import actions from './constants';

export const updateDatasetProperties = (category, code, properties) => ({
  type: actions.UPDATE_DATASET_PROPERTIES,
  category,
  code,
  properties,
});

export const updateActiveDatasetProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_DATASET_PROPERTIES,
  properties,
});

export const fetchDataset = (category, code) => ({
  type: actions.FETCH_DATASET,
  category,
  code,
});

export const newDatasetFromSource = (category, code, datasetSourceType, datasetSourceCode) => ({
  type: actions.NEW_DATASET_FROM_SOURCE,
  category,
  code,
  datasetSourceType,
  datasetSourceCode,
});

export const showDataset = (category, code, result) => ({
  type: actions.SHOW_DATASET,
  category,
  code,
  result,
});

export const showCloneDataset = (category, code, result, template) => ({
  type: actions.SHOW_CLONE_DATASET,
  category,
  code,
  result,
  template,
});

export const showNewDataset = (category, code, templateCode, template) => ({
  type: actions.SHOW_NEW_DATASET,
  category,
  code,
  templateCode,
  template,
});

export const showDatasetError = (category, code, error) => ({
  type: actions.SHOW_DATASET_ERROR,
  category,
  code,
  error,
});

export const editDataset = (category, code, template) => ({
  type: actions.EDIT_DATASET,
  category,
  code,
  template,
});

export const updateDataset = (category, code, properties, template) => ({
  type: actions.UPDATE_DATASET,
  category,
  code,
  properties,
  template,
});

export const updateDatasetCatalogue = (category, code, catalogue, template) => ({
  type: actions.UPDATE_DATASET_CATALOGUE,
  category,
  code,
  catalogue,
  template,
});

export const refreshDatasetSettings = (code, result) => ({
  type: actions.REFRESH_DATASET_SETTINGS,
  code,
  result,
});

export const datasetSettingsChanged = (code, name, result, silent) => ({
  type: actions.DATASET_SETTINGS_CHANGED,
  code,
  name,
  result,
  silent,
});

export const updateDatasetSuccess = (code, result, template, permissions) => ({
  type: actions.UPDATE_DATASET_SUCCESS,
  code,
  result,
  template,
  allowAttachments: permissions.attachments.create,
});

export const updateDatasetCatalogueSuccess = (code, result, template, permissions) => ({
  type: actions.UPDATE_DATASET_CATALOGUE_SUCCESS,
  code,
  result,
  template,
  allowAttachments: permissions.attachments.create,
});

export const updateDatasetError = (category, code, error) => ({
  type: actions.UPDATE_DATASET_ERROR,
  category,
  code,
  error,
});

export const updateDatasetCancel = (category, code) => ({
  type: actions.UPDATE_DATASET_CANCEL,
  category,
  code,
});

export const closeDataset = ({ category, code }) => ({
  type: actions.CLOSE_DATASET,
  category,
  code,
});

export const confirmDatasetDeletion = (dataset) => ({
  type: actions.SHOW_DELETE_DATASET,
  dataset,
});

export const confirmDatasetsDeletion = (category) => ({
  type: actions.SHOW_DELETE_DATASETS,
  category,
});

export const updateDatasetsFilter = (category, value) => ({
  type: actions.UPDATE_DATASETS_FILTER,
  category,
  value,
});

export const fetchDatasets = (category, page, pageSize, append) => ({
  type: actions.FETCH_DATASETS,
  category,
  page,
  pageSize,
  append,
});

export const refreshDatasets = (category, page) => ({
  type: actions.REFRESH_DATASETS,
  category,
  page,
});

export const toggleDatasetSelected = (category, code) => ({
  type: actions.TOGGLE_DATASET_SELECTED,
  category,
  code,
});

export const toggleDatasetsSelected = (category, selected) => ({
  type: actions.TOGGLE_DATASETS_SELECTED,
  category,
  selected,
});

export const updateDatasetsFlags = (category, { privateFlag, internalFlag, publicFlag }) => ({
  type: actions.UPDATE_DATASETS_FLAGS,
  category,
  privateFlag,
  internalFlag,
  publicFlag,
});

export const toggleDatasetColumnOrderBy = (category, orderByColumn) => ({
  type: actions.TOGGLE_DATASET_COLUMN_ORDER_BY,
  category,
  orderByColumn,
});

export const toggleDatasetsSingleSorting = (category) => ({
  type: actions.TOGGLE_DATASET_SINGLE_SORTING,
  category,
});

export const toggleDatasetsPresentation = (category, display) => ({
  type: actions.TOGGLE_DATASETS_PRESENTATION,
  category,
  display,
});

export const showDatasetsResults = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_DATASETS_RESULTS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showDatasetsError = (category, error) => ({
  type: actions.SHOW_DATASETS_ERROR,
  category,
  error,
});

export const closeDatasets = ({ category }) => ({
  type: actions.CLOSE_DATASETS,
  category,
});

export const updataDatasetValidationErrors = (category, code, errors) => ({
  type: actions.UPDATE_DATASET_VALIDATION_ERRORS,
  category,
  code,
  errors,
});

export const showSaveDataset = (category, code, template) => ({
  type: actions.SHOW_SAVE_DATASET,
  category,
  code,
  template,
});

export const hideSaveDataset = () => ({
  type: actions.HIDE_SAVE_DATASET,
});

export const createActiveDataset = () => ({
  type: actions.CREATE_ACTIVE_DATASET,
});

export const createDataset = (category, code, template) => ({
  type: actions.CREATE_DATASET,
  category,
  code,
  template,
});

export const newDataset = (category, code, previousUrl, result, template, permissions, silent) => ({
  type: actions.NEW_DATASET,
  category,
  code,
  result,
  template,
  allowAttachments: permissions.attachments.create,
  silent,
  previousUrl,
});

export const newDatasetError = (category, code, error) => ({
  type: actions.NEW_DATASET_ERROR,
  category,
  code,
  error,
});

export const deleteDataset = ({ items }) => ({
  type: actions.DELETE_DATASET,
  items,
});

export const destroyDataset = (items, silent) => ({
  type: actions.DESTROY_DATASET, items, silent,
});

export const destroyDatasetError = (items) => ({
  type: actions.DESTROY_DATASET_ERROR, items,
});

export const hideDeleteDataset = () => ({
  type: actions.HIDE_DELETE_DATASET,
});

export const newDictionarySuccess = (category, code, result, newDictionaryName) => ({
  type: actions.NEW_DICTIONARY_SUCCESS,
  category,
  code,
  result,
  newDictionaryName,
});

export const newDictionaryError = (category, code, error) => ({
  type: actions.NEW_DICTIONARY_ERROR,
  category,
  code,
  error,
});

export const convertToDictionary = (category, code, attachmentId, properties, isNew) => ({
  type: actions.CONVERT_TO_DICTIONARY,
  category,
  code,
  attachmentId,
  properties,
  isNew,
});

export const convertToDictionarySuccess = (category, code, attachmentId, dictionaryName, isNew, deleteSource) => ({
  type: actions.CONVERT_TO_DICTIONARY_SUCCESS,
  category,
  code,
  attachmentId,
  dictionaryName,
  isNew,
  deleteSource,
});

export const convertToDictionaryError = (dictionaryName) => ({
  type: actions.CONVERT_TO_DICTIONARY_ERROR,
  dictionaryName,
});

export const updateCurrentDatasetPermissions = (code, permissions) => ({
  type: actions.UPDATE_CURRENT_DATASET_PERMISSIONS,
  code,
  permissions,
});

export const toggleDatasetPreview = (category, code) => ({
  type: actions.TOGGLE_DATASET_PREVIEW,
  category,
  code,
});

export const updateActiveDatasetStep = (category, code, step, template) => ({
  type: actions.UPDATE_DATASET_STEP,
  category,
  code,
  step,
  template,
});

export const toggleDatasetWizard = (category, code, template) => ({
  type: actions.TOGGLE_DATASET_WIZARD,
  category,
  code,
  template,
});

export const finishDatasetWizard = (category, code) => ({
  type: actions.FINISH_DATASET_WIZARD,
  category,
  code,
});

export const downloadDatasetError = (code, error) => ({
  type: actions.DOWNLOAD_DATASET_ERROR,
  code,
  error,
});
